import React from 'react'
import { NavLink } from 'react-router-dom'

import BetaLabel from 'Components/BetaLabel'

export const SidebarButtonUnstyled = props => {
  return (
    <NavLink
      activeClassName="active"
      className={props.className}
      to={props.to || ''}
      id={props.id}
      isActive={props.isActive}
      target={props.target}
    >
      {props.children}
      {props.inBeta ? <BetaLabel /> : null}

      <div className={'icon'}>{props.icon}</div>
    </NavLink>
  )
}
